export enum UserPreferenceKey {
	PAGE_HELPER_CUSTOMER_INDEX = 'page-helper-customer-index',
	PAGE_HELPER_DASHBOARD = 'page-helper-dashboard',
	PAGE_HELPER_MARKETING_CANCELLATION_REASON_INDEX = 'page-helper-marketing-cancellation-reason-index',
	PAGE_HELPER_MARKETING_OFFER_INDEX = 'page-helper-marketing-offer-index',
	PAGE_HELPER_MARKETING_SKIP_REASON_INDEX = 'page-helper-marketing-skip-reason-index',
	PAGE_HELPER_CANCEL_FLOWS = 'page-helper-cancel-flows',
	PAGE_HELPER_MERCHANDISING_ASSORTMENT_INDEX = 'page-helper-merchandising-assortment-index',
	PAGE_HELPER_EXPERIENCE_COLLECTION_GROUPS_INDEX = 'page-helper-experience-collection-groups-index',
	PAGE_HELPER_MERCHANDISING_PRICE_SHEET_INDEX = 'page-helper-merchandising-price-sheet-index',
	PAGE_HELPER_MERCHANDISING_PRODUCT_DROP_TEMPLATE_INDEX = 'page-helper-merchandising-product-drop-template-index',
	PAGE_HELPER_MERCHANDISING_PRODUCT_DROP_INDEX = 'page-helper-merchandising-product-drop-index',
	PAGE_HELPER_MERCHANDISING_THRESHOLDS_INDEX = 'page-helper-merchandising-thresholds-index',
	PAGE_HELPER_SUBSCRIPTION_PRODUCT_TYPE_GROUP_INDEX = 'page-helper-subscription-product-type-group-index',
	PAGE_HELPER_SUBSCRIPTION_PLAN_INDEX = 'page-helper-subscription-plan-index',
	PAGE_HELPER_SUBSCRIPTION_THEME_INDEX = 'page-helper-subscription-theme-index',
	PAGE_HELPER_TOOLS_FLOWS_INDEX = 'page-helper-tools-flows-index',
}

export interface UserPreferenceValue {
	isPageHelperOpen?: boolean;
}
